export default __webpack_public_path__ + "static/cafe_36089-844a5dcb5103a15e0429c620ddf1cfae.png";